module.exports = __webpack_public_path__ + "c0ddd54bc36224674514784c0fad9f26.svg";